export enum FormControlNameEnum {
  COUNTRY_CD = 'countryCd',
  INPUT_METHOD = 'inputMethod',
  ROUTE_TYPE = 'routeType',
  ZIP_CD = 'zipCd',
  STATE = 'state',
  CITY = 'city',
}
